module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Pulse</h1>\n</div>\n<iframe src=\"apps/pulse/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/pulse/pulse.component.html
// module id = ../../../../../src/app/pages/pulse/pulse.component.html
// module chunks = main